export default __webpack_public_path__ + "static/media/PropostasAtivas.1742da79.svg";